(function($) {

  Drupal.behaviors.mpp_custom_sample_mini_bar_v1 = {
    attach: function(context, settings) {
      var productsArray = page_data['catalog-mpp'].products;
      $(".js-product-brief").each(function() {
        var productId = $(this).attr('data-product-id');
        var productData = _.find(productsArray, function(p) {
          return p.PRODUCT_ID == productId;
        });
        site.product.view.extendedMPP({
          containerNode: this,
          productData: productData
        });

        //ie8 pie attach behavior
        if (generic.env.isIE8) {
          if (window.PIE) {
            $('.swatches--single div').each(function(i, el) {
              PIE.attach(this);
            });
          }
        }
      });

      site.product.view.miscFlagAlign($('.mpp__product'));
      site.product.view.equalRowHeight($('.mpp__product'));
      //Update Row Bottom Content
      site.product.view.equalMPPRowBottomHeightFunc($('.mpp__product'));

      $('.mpp__product-grid .mpp__product:nth-child(3n+2)').addClass('nth-child-3np2');
      $(".product_brief__image").off('mouseover').off('mouseout');

      $(".product_brief__image").mouseover(function() {
        var newBgImg = $(this).attr('data-sku-alt-image');
        if($(this).next()[0].naturalWidth != 0) {
         $(this).attr("src", newBgImg);
        }
        $(this).parent().nextAll(".rollover_plus").find("img").attr("src","/media/export/cms/mpp/minus.png");
      }).mouseout(function() {
        var newBgImg = $(this).attr('data-sku-image');
        $(this).attr("src", newBgImg);
        $(this).parent().nextAll(".rollover_plus").find("img").attr("src","/media/export/cms/mpp/plus.png");
      });

      $(".rollover_plus").on("mouseover",function() {
        var imgContainer = $(this).prev().find('.product_brief__image');
        var newBgImg = imgContainer.attr('data-sku-alt-image');
        if(imgContainer.next()[0].naturalWidth != 0) {
         imgContainer.attr("src", newBgImg);
        }
        $(this).find("img").attr("src","/media/export/cms/mpp/minus.png");
      }).on("mouseout",function() {
        var imgContainer = $(this).prev().find('.product_brief__image');
        var newBgImg = imgContainer.attr('data-sku-image');
        imgContainer.attr("src", newBgImg);
        $(this).find("img").attr("src","/media/export/cms/mpp/plus.png");
      });

    }
  };

})(jQuery);
